var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    attrs: {
      id: "emailSetting"
    }
  }, [_c("a-form-model", {
    ref: "ruleForm",
    staticStyle: {
      "max-width": "300px"
    },
    attrs: {
      rules: _vm.rules,
      model: _vm.dataForm
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("basicSettings.SMTPHost"),
      prop: "SMTPHost"
    }
  }, [_c("a-input", {
    staticClass: "cfinput_class",
    attrs: {
      maxLength: 200,
      allowClear: true,
      placeholder: _vm.$t("publicuse.pleaseinput")
    },
    model: {
      value: _vm.dataForm.SMTPHost,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "SMTPHost", $$v);
      },
      expression: "dataForm.SMTPHost"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("basicSettings.SMTPAccount"),
      prop: "SMTPAccount"
    }
  }, [_c("a-input", {
    staticClass: "cfinput_class",
    attrs: {
      maxLength: 200,
      allowClear: true,
      placeholder: _vm.$t("publicuse.pleaseinput")
    },
    model: {
      value: _vm.dataForm.SMTPAccount,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "SMTPAccount", $$v);
      },
      expression: "dataForm.SMTPAccount"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("basicSettings.SMTPPassword"),
      prop: "SMTPPassword"
    }
  }, [_c("a-input", {
    staticClass: "cfinput_class",
    attrs: {
      maxLength: 200,
      type: "password",
      allowClear: true,
      placeholder: _vm.$t("publicuse.pleaseinput")
    },
    model: {
      value: _vm.dataForm.SMTPPassword,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "SMTPPassword", $$v);
      },
      expression: "dataForm.SMTPPassword"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("basicSettings.SMTPPort"),
      prop: "SMTPPort"
    }
  }, [_c("a-input", {
    staticClass: "cfinput_class",
    attrs: {
      maxLength: 200,
      allowClear: true,
      placeholder: _vm.$t("publicuse.pleaseinput")
    },
    model: {
      value: _vm.dataForm.SMTPPort,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "SMTPPort", $$v);
      },
      expression: "dataForm.SMTPPort"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("basicSettings.SMTPTimeout"),
      prop: "SMTPTimeout"
    }
  }, [_c("a-input", {
    staticClass: "cfinput_class",
    attrs: {
      maxLength: 200,
      allowClear: true,
      placeholder: _vm.$t("publicuse.pleaseinput")
    },
    model: {
      value: _vm.dataForm.SMTPTimeout,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "SMTPTimeout", $$v);
      },
      expression: "dataForm.SMTPTimeout"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("basicSettings.earlyWarning")
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.dataForm.abnormalMessageStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "abnormalMessageStatus", $$v);
      },
      expression: "dataForm.abnormalMessageStatus"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("public.open")) + " ")]), _c("a-radio", {
    attrs: {
      value: 0
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("public.close")) + " ")])], 1)], 1), _c("a-form-model-item", {
    staticStyle: {
      width: "600px"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_vm._v(" " + _vm._s(_vm.$t("basicSettings.administratorEmail")) + "  "), _c("a-tooltip", {
    attrs: {
      title: _vm.$t("basicSettings.administratorEmailPrompt")
    }
  }, [_c("a-icon", {
    attrs: {
      type: "info-circle"
    }
  })], 1)], 1), _c("a-textarea", {
    staticClass: "cfinput_class",
    attrs: {
      maxLength: 200,
      allowClear: true,
      placeholder: _vm.$t("publicuse.pleaseinput")
    },
    model: {
      value: _vm.dataForm.adminEmail,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "adminEmail", $$v);
      },
      expression: "dataForm.adminEmail"
    }
  })], 1), _c("a-form-model-item", [_c("a-button", {
    attrs: {
      type: "primary",
      loading: _vm.loadingSave
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.save")))])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };